import Cookies from "js-cookie";

const languageMap: { [key: string]: string } = {
  en: "en-gb",
  de: "de-DE",
  it: "it-IT",
  fr: "fr-FR",
};

export const languageIds: { [key: string]: string } = {
  en: "1",
  de: "2",
  it: "4",
  fr: "3",
};

export const getLanguage = (locale?: string) => {
  if (!locale) {
    locale = Cookies.get("locale");
  }

  return locale ? languageMap[locale] : "de-DE";
};
